import React from "react";

import Image from "next/image";

import FigureImage from "public/images/enerflo-support-how-can-we-help.png";

import Heading from "components/heading";
import HeroSection from "components/hero-section";

const title = "Enerflo Operating System · Support";

const MainHero = () => {
  return (
    <div className="bg-navy">
      <HeroSection title={title} className="flex-col md:flex-row">
        <HeroSection.Content className="md:w-3/5">
          <HeroSection.Tagline className="text-white mb-4">{title}</HeroSection.Tagline>
          <HeroSection.Header className="md:items-start">
            <Heading tag="h1">
              <span className="text-white">Support that moves as fast as</span>{" "}
              <span className="text-primary">the deals you’re closing.</span>
            </Heading>
          </HeroSection.Header>
          <HeroSection.Description className="text-lg text-gray-200 max-w-5xl mx-auto">
            The Enerflo OS is only as good as the team behind it. Our support specialists know residential solar (deal
            flow, lender integrations, install tracking, AHJ requirements) and they’re here to keep your team moving
            from first knock to PTO (Permission to Operate).
          </HeroSection.Description>
        </HeroSection.Content>

        <figure className="p-3 w-full xs:w-4/5 sm:w-3/4 md:w-2/5">
          <Image
            src={FigureImage}
            alt="Enerflo Product Support."
            layout="responsive"
            quality={100}
            placeholder="blur"
            loading="eager"
            priority
            className="crispImage"
            sizes="(min-width: 768px) 50vw, 100vw"
          />
        </figure>
      </HeroSection>
    </div>
  );
};

export default MainHero;
